import { apiClient } from './client.js';

export interface ReferralCredit {
  id: string;
  source: 'REFEREE_OFFER' | 'REFERRER_BASE' | 'MILESTONE_3_FREE_ENTRY' | 'MILESTONE_5_FREE_ENTRIES';
  discountPercent: number;
  totalSessions: number;
  remainingSessions: number;
  status: 'ACTIVE' | 'USED';
  createdAt: string;
}

export interface ReferralDashboard {
  referralCode: string;
  referralUrl: string;
  convertedCount: number;
  milestones: Array<{ referrals: number; reward: string; reached: boolean }>;
  referrals: Array<{
    id: string;
    status: 'PENDING' | 'CONVERTED';
    convertedAt: string | null;
    createdAt: string;
    refereeAccount: { email: string; firstName: string | null; lastName: string | null };
  }>;
  credits: ReferralCredit[];
  rewards: Array<{
    id: string;
    milestone: number;
    reward: 'FREE_ENTRY' | 'TWO_FREE_ENTRIES';
    status: 'GRANTED' | 'APPLIED';
    grantedAt: string;
  }>;
}

export const referralsApi = {
  me: () => apiClient.get<ReferralDashboard>('/referrals/me'),
};
